import { render, staticRenderFns } from "./LogoMenu.vue?vue&type=template&id=54ee6d44&scoped=true&"
import script from "./LogoMenu.vue?vue&type=script&lang=js&"
export * from "./LogoMenu.vue?vue&type=script&lang=js&"
import style0 from "./LogoMenu.vue?vue&type=style&index=0&id=54ee6d44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee6d44",
  null
  
)

export default component.exports